import config from "../../config/config";

const appTranslations = [
    { code: "en", displayName: "English" },
    { code: "de", displayName: "German" },
    { code: "es", displayName: "Spanish" },
    { code: "zh-CN", displayName: "Simplified Chinese" },
    { code: "fr", displayName: "French" },
    { code: "ja", displayName: "Japanese" },
    { code: "pt", displayName: "Portuguese" },
    { code: "zh-TW", displayName: "Traditional Chinese" },
    { code: "sr", displayName: "Serbian" },
    { code: "pseudoLanguage", displayName: "Pseudo language" }
];

// Keep Serbian and Pseudo Language on the end of the array
if (!['dev', 'stage'].includes(config.environment)) {
    appTranslations.splice(8, appTranslations.length - 1);
}

export default appTranslations;
